import { Path } from '@/main/router/routerPath';

import { CRUMB_LABEL_KEY, NAME } from './constants';

export const router = new Path(NAME, { }, CRUMB_LABEL_KEY);
